import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import CHART_COLORS from "./chartColors";

const StarRatingChart = ({ question, results }) => {
	const starData = [];

	for (let stars = 5; stars >= 1; stars--) {
		const starResponse = results.responses.find(response => {
			return response.responseKey === stars.toString();
		});

		starData.push({
			stars: `${stars} Star${stars > 1 ? "s" : ""}`,
			percentage: starResponse ? starResponse.percentage : 0,
			count: starResponse ? starResponse.count : 0,
			fill: CHART_COLORS[(5 - stars) % CHART_COLORS.length],
			starValue: stars,
		});
	}

	// Generate star icons for labels
	const renderStarLabel = starValue => {
		return "★".repeat(starValue) + "☆".repeat(5 - starValue);
	};

	const customTickFormatter = value => {
		const item = starData.find(d => d.stars === value);
		return item ? renderStarLabel(item.starValue) : value;
	};

	return (
		<div className="chart-container star-rating-chart">
			<div className="chart-header">
				<h4>{question.title}</h4>
				{question.subtitle && <p className="chart-subtitle">{question.subtitle}</p>}
			</div>

			<ResponsiveContainer width="100%" height={300}>
				<BarChart layout="vertical" data={starData} margin={{ right: 20 }}>
					<CartesianGrid strokeDasharray="3 3" horizontal={false} />
					<XAxis type="number" domain={[0, 100]} tickFormatter={value => `${value}%`} />
					<YAxis
						type="category"
						dataKey="stars"
						tick={{ fontSize: 16 }}
						tickFormatter={customTickFormatter}
						width={100}
					/>
					<Tooltip
						cursor={{ fill: "transparent" }}
						formatter={(value, name, props) => [
							`${value}% (${props.payload.count} ${props.payload.count === 1 ? "vote" : "votes"})`,
							`${props.payload.starValue} Star${props.payload.starValue > 1 ? "s" : ""}`,
						]}
						labelFormatter={(label, payload) => {
							if (payload && payload[0]) {
								return renderStarLabel(payload[0].payload.starValue);
							}
							return label;
						}}
					/>
					<Bar dataKey="percentage" radius={[0, 4, 4, 0]}>
						{starData.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={entry.fill} />
						))}
					</Bar>
				</BarChart>
			</ResponsiveContainer>

			<div className="chart-footer">Total Votes: {results.totalVotes}</div>
		</div>
	);
};

export default StarRatingChart;
